// extracted by mini-css-extract-plugin
export default {"root":"IconArrowCarousel_root__I3GkO"};